"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PasswordStrength = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _zxcvbn2 = _interopRequireDefault(require("zxcvbn"));
var _utils = require("../../utils");
var _fonts = require("./fonts");
var _Progress = require("./Progress");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var styleByScore = (0, _utils.stylesBy)(function (props) {
  return props.value;
});
var backgroundColor = styleByScore({
  75: function _(_ref) {
    var theme = _ref.theme;
    return theme.colors.warning;
  },
  100: function _(_ref2) {
    var theme = _ref2.theme;
    return theme.colors.success;
  }
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.danger;
});
var Progress = (0, _styledComponents.default)(_Progress.Progress)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex: 1;\n  .progress-bar {\n    background-color: ", ";\n  }\n"])), backgroundColor);
var PasswordStrengthWrapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding-bottom: 20px;\n"])));
var P = (0, _styledComponents.default)(_fonts.P)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-bottom: 0;\n  ", "\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.tertiary;
}, _utils.mediaQuery.lessThan('sm')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    font-size: 14px;\n  "]))));
var H6 = (0, _styledComponents.default)(_fonts.H6)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-right: 8px;\n  margin-left: 25px;\n  margin-bottom: 0;\n  ", "\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.tertiary;
}, _utils.mediaQuery.lessThan('sm')(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    margin-left: 14px;\n  "]))));
var PasswordStrength = function PasswordStrength(props) {
  var _props$password;
  var _useTranslation = (0, _reactI18next.useTranslation)('libAuth'),
    t = _useTranslation.t;
  var _zxcvbn = (0, _zxcvbn2.default)((_props$password = props.password) !== null && _props$password !== void 0 ? _props$password : ''),
    score = _zxcvbn.score;
  var progressValue = score * 25;
  return /*#__PURE__*/_react.default.createElement(PasswordStrengthWrapper, null, /*#__PURE__*/_react.default.createElement(Progress, {
    value: progressValue
  }), /*#__PURE__*/_react.default.createElement(H6, null, progressValue, "%"), /*#__PURE__*/_react.default.createElement(P, null, t('passwordStrength')));
};
exports.PasswordStrength = PasswordStrength;